var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Select,{attrs:{"placeholder":_vm.$t('welcome_signs.select_a_welcome_sign'),"url":_vm.url,"value":_vm.value},on:{"input":function($event){return _setup.emit('input', $event)},"change":function($event){return _setup.emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }